import { useWatch, useFormContext } from "react-hook-form";
import { Typography } from "@mui/material";
import { IGoodsTransfer } from "../../../../types/Inventory/GoodsTransfer";

type Props = {
  nestedIndex: number;
  keyTrace: "qty" | "stock_qty";
};

const GoodsTransferTotalPostedQuantityCell = ({
  nestedIndex,
  keyTrace,
}: Props) => {
  const { control } = useFormContext<IGoodsTransfer>();
  const watchSerialList =
    useWatch({
      control,
      name: `trace_entry_list.${nestedIndex}.serial_list` as `trace_entry_list`,
    }) || [];

  const totalPostedQuantity = watchSerialList.reduce((prev, curr) => {
    const qty = curr[keyTrace] ?? 0;

    if (qty) {
      if (typeof qty === "string") {
        return prev + parseInt(qty);
      } else {
        return prev + qty;
      }
    } else {
      return prev + 0;
    }
  }, 0);

  return <Typography fontSize={14}>{totalPostedQuantity}</Typography>;
};

export default GoodsTransferTotalPostedQuantityCell;
